import { log } from "~features/seated-reservation/helpers/stateLogger";
import { getState, setState } from "../index";

interface ActionProps {
  id: string;
  quantity: number;
}

export const updateAddon = (payload: ActionProps) => {
  log("updateAddon", payload);

  const state = getState();

  return setState({
    addons: {
      ...state.addons,
      [payload.id]: payload.quantity,
    },
  });
};
